import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './TeamPage.css';

const TeamPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="team-page">
      <div className="team-container">
        <button className="back-button" onClick={handleBack}>
          <span className="back-arrow">←</span>
          Back
        </button>
        
        <div className="team-content">
          <h1>Meet Our Team</h1>
          <p className="team-subtitle">Dedicated professionals committed to revolutionizing immigration assistance through technology</p>
          
          <div className="team-grid">
            <div className="team-member">
              <div className="member-photo">
                <img src="/team/member1.jpg" alt="Team Member" onError={(e) => {
                  e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiByeD0iNjAiIGZpbGw9IiNFNUU3RUIiLz4KPHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSI0MCIgeT0iMzAiPgo8cGF0aCBkPSJNMjAgMjBDMjIuNzYxNCAyMCAyNSAxNy43NjE0IDI1IDE1QzI1IDEyLjIzODYgMjIuNzYxNCAxMCAyMCAxMEMxNy4yMzg2IDEwIDE1IDEyLjIzODYgMTUgMTVDMTUgMTcuNzYxNCAxNy4yMzg2IDIwIDIwIDIwWiIgZmlsbD0iIzlDQTNBRiIvPgo8cGF0aCBkPSJNMzAgMzBDMzAgMjUuNTgxNyAyNS41MjI4IDIyIDIwIDIyQzE0LjQ3NzIgMjIgMTAgMjUuNTgxNyAxMCAzMEgxMEMxMCAzMi43NjE0IDEyLjIzODYgMzUgMTUgMzVIMjVDMjcuNzYxNCAzNSAzMCAzMi43NjE0IDMwIDMwWiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4KPC9zdmc+';
                }} />
              </div>
              <div className="member-info">
                <h3>Narender Aeron</h3>
                <p className="member-title">Founder</p>
                <p className="member-bio">
                  Founder of CaseKaizen, Narender draws on two decades of experience leading software engineering teams and building scalable platforms.
                  He drives both the technical vision and hands-on development behind CaseKaizen's intelligent legal assistant.
                </p>
                <div className="member-social">
                  <a href="https://www.linkedin.com/in/narenderaeron/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
            
            <div className="team-member">
              <div className="member-photo">
                <img src="/team/member2.jpg" alt="Team Member" onError={(e) => {
                  e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiByeD0iNjAiIGZpbGw9IiNFNUU3RUIiLz4KPHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSI0MCIgeT0iMzAiPgo8cGF0aCBkPSJNMjAgMjBDMjIuNzYxNCAyMCAyNSAxNy43NjE0IDI1IDE1QzI1IDEyLjIzODYgMjIuNzYxNCAxMCAyMCAxMEMxNy4yMzg2IDEwIDE1IDEyLjIzODYgMTUgMTVDMTUgMTcuNzYxNCAxNy4yMzg2IDIwIDIwIDIwWiIgZmlsbD0iIzlDQTNBRiIvPgo8cGF0aCBkPSJNMzAgMzBDMzAgMjUuNTgxNyAyNS41MjI4IDIyIDIwIDIyQzE0LjQ3NzIgMjIgMTAgMjUuNTgxNyAxMCAzMEgxMEMxMCAzMi43NjE0IDEyLjIzODYgMzUgMTUgMzVIMjVDMjcuNzYxNCAzNSAzMCAzMi43NjE0IDMwIDMwWiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4KPC9zdmc+';
                }} />
              </div>
              <div className="member-info">
                <h3>Ishan Keezhakada</h3>
                <p className="member-title">Cofounder, Software Engineer</p>
                <p className="member-bio">
                  With a B.S. in Computer Science and internships at Ciena, Fidelity, and ARIA Cybersecurity, 
                  Ishan brings real‑world software development experience to CaseKaizen. He guides technical 
                  design and implementation, helping deliver an efficient and trustworthy legal‑tech solution.
                </p>
                <div className="member-social">
                  <a href="https://www.linkedin.com/in/ishan-keezhakada-23a9b7218/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
            
            <div className="team-member">
              <div className="member-photo">
                <img src="/team/member3.jpg" alt="Team Member" onError={(e) => {
                  e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiByeD0iNjAiIGZpbGw9IiNFNUU3RUIiLz4KPHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSI0MCIgeT0iMzAiPgo8cGF0aCBkPSJNMjAgMjBDMjIuNzYxNCAyMCAyNSAxNy43NjE0IDI1IDE1QzI1IDEyLjIzODYgMjIuNzYxNCAxMCAyMCAxMEMxNy4yMzg2IDEwIDE1IDEyLjIzODYgMTUgMTVDMTUgMTcuNzYxNCAxNy4yMzg2IDIwIDIwIDIwWiIgZmlsbD0iIzlDQTNBRiIvPgo8cGF0aCBkPSJNMzAgMzBDMzAgMjUuNTgxNyAyNS41MjI4IDIyIDIwIDIyQzE0LjQ3NzIgMjIgMTAgMjUuNTgxNyAxMCAzMEgxMEMxMCAzMi43NjE0IDEyLjIzODYgMzUgMTUgMzVIMjVDMjcuNzYxNCAzNSAzMCAzMi43NjE0IDMwIDMwWiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4KPC9zdmc+';
                }} />
              </div>
              <div className="member-info">
                <h3>Pankaj Jain</h3>
                <p className="member-title">Advisor, Immigration Attorney</p>
                <p className="member-bio">
                  Pankaj is a practicing immigration lawyer and founder of Jain Law Corporation. 
                  He advises CaseKaizen on legal accuracy and workflow relevance, ensuring our tools 
                  align with the realities of immigration practice.
                </p>
                <div className="member-social">
                  <a href="https://www.linkedin.com/in/pankaj-jain-immigration-lawyer/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TeamPage;
